import { CategoryLeaderboardViewState } from '@models/SavedViews';
import CreateCopyViewButton from '../copy-view/CreateCopyViewButton';
import React from 'react';
import { SavedViewButtonsTrackingTags } from '@ecosystem/newron-client-lib/build/saved-views/types';

export interface Props {
  categoryLeaderboardViewState: CategoryLeaderboardViewState;
  copyViewTracking: Object;
}

const CategoryLeaderboardCopyViewButton: React.FC<Props> = ({ categoryLeaderboardViewState, copyViewTracking }) => {
  const createViewState = () => {
    return categoryLeaderboardViewState;
  };
  const createTrackingTags = () => {
    return copyViewTracking as SavedViewButtonsTrackingTags;
  };

  return <CreateCopyViewButton createViewFunction={createViewState} copyViewTracking={createTrackingTags} />;
};

export default CategoryLeaderboardCopyViewButton;
